import { OnInit, Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IResult } from 'app/shared/models/result.model';
import { Subject } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { LiquidationService } from 'app/views/appviews/liquidation.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoDiscountDismissal } from 'app/shared/models/legal/dto-discount-dismissal.model';
import { SecurityService } from 'app/shared/services/security.service';

@Component({
    selector: 'app-modal-discount-dismissal',
    templateUrl: './modal-discount-dismissal.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalDiscountDismissalComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formDiscount: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Notificaciones */
    private configToast: any;
    /**Retorno a pantalla padre */
    public onClose: Subject<any>;
    private catalogDiscountTypes: IDtoCatalog[];
    private listDiscount: IDtoDiscountDismissal[];
    private employeeId: number;
    private requisitionId: number;
    private userId: number;
    private showRoles: any;
    @ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , public snotifyService: SnotifyService
        , private configGeneral: AppConfig
        , private liquidationService: LiquidationService
        , private securityService: SecurityService) {
        this.initializeFormUserRole();
        this.configToast = this.configGeneral.getConfigToast();
        this.showRoles = this.securityService.getUserRolesStorage();
        if (this.showRoles !== '') {
            this.userId = +this.showRoles.employeeId;
        }
    }
    ngOnInit(): void {
        this.onClose = new Subject();
         this.liquidationService.getCatalogDiscountTypes()  .subscribe(
            (x) => {
                this.catalogDiscountTypes = x;
            },
            (errMessage) => this.errorMessages = errMessage.messages
        );
        this.getDiscountDismissals();
    }
    private initializeFormUserRole() {
        this.formDiscount = this.formBuilder.group({
            discountTypeId: [null, [Validators.required]],
            value: [null, [Validators.required]]
        });
    }
    private submit(): void {
        if (this.formDiscount.valid) {
            this.save();
        } else {
            this.snotifyService.error('Capture toda la información requerida para poder continuar'
                , 'Validación', this.configToast);
        }
    }
    private save(): void {
        const data = this.formDiscount.value as IDtoDiscountDismissal;
        let discountType = this.catalogDiscountTypes.find(x => x.id == data.discountTypeId);
        data.codeNom = discountType.additional;
        data.description = discountType.name;
        data.employeeId = this.employeeId;
        data.requisitionId = this.requisitionId;
        data.userId = this.userId;
        this.liquidationService.addDiscountDismissal(data)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        this.getDiscountDismissals();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private getDiscountDismissals(): void {
        this.liquidationService.getDiscountDismissals(this.employeeId, this.requisitionId)
            .subscribe(
                (x) => {
                    this.listDiscount = x;
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    
    private delete(item: IDtoDiscountDismissal): void {
        if(item.userId == this.userId) {
            this.liquidationService.deleteDiscountDismissal(item.id)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        this.getDiscountDismissals();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
        } else {
                this.configGeneral.newToast('Validación', "No es posible eliminar este descuento debido a restricciones de perfil.", 'error');
        }
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
}
